// extracted by mini-css-extract-plugin
export default {"globalColors":"colors_globalColors__9EVAf"};